import styled from "styled-components";
import * as colors from "../../settings/colors";
import * as metrics from "../../settings/metrics";

const TabBar = styled.div`
  display: flex;
  background: white;
  padding-top: ${metrics.CONTENT_PADDING / 2}px;
  border-bottom: ${props =>
    props.bordered ? `1px solid ${colors.DIVIDER}` : 0};
  z-index: 20;
`;

export default TabBar;



// WEBPACK FOOTER //
// ./src/components/tabs/TabBar.js